import { render } from "./SmartSliderThumbnail.vue?vue&type=template&id=3b84e719&scoped=true"
import script from "./SmartSliderThumbnail.vue?vue&type=script&lang=js"
export * from "./SmartSliderThumbnail.vue?vue&type=script&lang=js"

import "./SmartSliderThumbnail.vue?vue&type=style&index=0&id=3b84e719&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b84e719"]])

export default __exports__